import type { User } from '@fluenceur/types';
import api from '@/libs/axiosInstance';

export interface UpdateUserProfileDto {
  firstName: string;
  lastName: string;
}

export const updateUserProfile = async (data: UpdateUserProfileDto): Promise<User> => {
  const response = await api.put('/dashboard/users', data);
  return response.data;
};

export interface UploadUserAvatarResponse {
  imageUrl: string;
}

export const uploadUserAvatar = async (file: File): Promise<string> => {
  const formData = new FormData();
  formData.append('image', file);

  const response = await api.post<UploadUserAvatarResponse>('/users/avatar', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response.data.imageUrl;
};

export const deleteUserAvatar = async (): Promise<void> => {
  await api.delete('/users/avatar');
};

export interface UpdateUserEmailDto {
  email: string;
  password: string;
}

export const updateUserEmail = async (data: UpdateUserEmailDto): Promise<User> => {
  const response = await api.put('/dashboard/users/email', data);
  return response.data;
};

export interface UpdateUserPasswordDto {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

export const updateUserPassword = async (data: UpdateUserPasswordDto): Promise<void> => {
  await api.patch('/dashboard/users/password', data);
};
